export class Actions {
  self = null;
  brandId = '';

  constructor(brandId, _this) {
    this.self = _this;
    this.brandId = brandId;

    // Timer de actualización de reproducciones
    setInterval(() => {
      this.updatePlaying();
    }, 10000);
  }

  /**
   * Devuelve las acciones pendientes de enviar
   *
   * @return 
   * @memberof Actions
   */
  getActions() {
    // Comprobamos si tenemos acciones pendientes de enviar
    var lastIntelActions = '';

    var lastintel = localStorage.getItem(this.brandId + "lastIntelActions");
    if (lastintel) {
      lastIntelActions = lastintel;
    }

    return lastIntelActions;

  }

  /**
   * Devuelve la información de las reproducciones
   *
   * @return 
   * @memberof Actions
   */
  getPlaying() {

    var last = localStorage.getItem(this.brandId + "lastIntelPlaying");

    if (!last) {
      return [];
    }

    // Limpiamos las reproducciones antiguas
    localStorage.setItem(this.brandId + "lastIntelPlaying", '');

    return JSON.parse(last);
  }

  updatePlaying() {

    var last = localStorage.getItem(this.brandId + "lastIntelPlaying");

    // Si no hay nada, seteamos un array vacío
    if (!last) {
      last = [];
    } else {
      last = JSON.parse(last);
    }
    
    // Recorre las reproducciones y obtiene los segundos
    for (var i = 0; i < this.self.players.length; i++) {

      // Si el created es 0, saltamos
      if (this.self.players[i].created == 0) {
        continue;
      }

      // Si en el storage ya teníamos una reproducción con el mismo content_id y date, actualizamos los segundos
      var found = last.find(p => p.content_id == this.self.players[i].contentId && p.date == this.self.players[i].created);
      if (found) {
        found.seconds = parseInt((Date.now() / 1000) - this.self.players[i].created);
      } else {

        // Si no, añadimos la reproducción
        last.push({
          date: this.self.players[i].created,
          content_id: this.self.players[i].contentId,
          seconds: parseInt((Date.now() / 1000) - this.self.players[i].created)
        });
      }

    }

    // Guardamos las reproducciones
    localStorage.setItem(this.brandId + "lastIntelPlaying", JSON.stringify(last));
  }

  /**
   * Limpia las acciones pendientes de enviar
   *
   * @memberof Actions
   */
  clear() {
    localStorage.setItem(this.brandId + "lastIntelActions", '');
  }

  /**
   * Añade una acción
   *
   * @param {*} action 
   * @param {*} [options={}] 
   * @memberof Actions
   */
  addAction(action, options = {}) {
    var content = options.content || 0;
    var product = options.product || 0;
    var price = options.price || 0;
    var play_token = options.play_token || 0;
    var playing_seconds = options.playing_seconds || 0;

    var osv = 0;
    var brov = 0;

    try {

      var os = [
        { id: 5, name: 'Windows', value: 'Win', version: 'NT' },
        { id: 7, name: 'iPhone', value: 'iPhone', version: 'OS' },
        { id: 6, name: 'iPad', value: 'iPad', version: 'OS' },
        { id: 2, name: 'Kindle', value: 'Silk', version: 'Silk' },
        { id: 1, name: 'Android', value: 'Android', version: 'Android' },
        { id: 4, name: 'Macintosh', value: 'Mac', version: 'OS X' },
        { id: 3, name: 'Linux', value: 'Linux', version: 'rv' }
      ];

      var browser = [
        { id: 5, name: 'Edge', value: 'Edg', version: 'Edg' },  // Coloca Edge antes de Chrome
        { id: 1, name: 'Chrome', value: 'Chrome', version: 'Chrome' },
        { id: 2, name: 'Firefox', value: 'Firefox', version: 'Firefox' },
        { id: 4, name: 'Safari', value: 'Safari', version: 'Version' },
        { id: 3, name: 'Mozilla', value: 'Mozilla', version: 'Mozilla' }
      ];

      var header = [
        navigator.platform,
        navigator.userAgent,
        navigator.appVersion,
        navigator.vendor,
        window.opera
      ];

      var agent = header.join(' ');

      // Detectar sistema operativo
      var ost = os.find(os => agent.indexOf(os.value) > -1);

      // Detectar navegador (con orden de prioridad corregido)
      var browsert = browser.find(browser => agent.indexOf(browser.value) > -1);

      // Obtener id de sistema operativo y navegador
      var osv = ost ? ost.id : null;
      var brov = browsert ? browsert.id : null;

      // Guardar en localstorage
      var lastIntelActions = localStorage.getItem(this.brandId + "lastIntelActions");
      lastIntelActions += action + ';' + content + ';' + osv + ';' + brov + ';' + Date.now() + ';' + product + ';' + price + ';' + play_token + ';' + playing_seconds + '|';
      localStorage.setItem(this.brandId + "lastIntelActions", lastIntelActions);
    } catch (error) {
      console.error(error);
    }
  }

}